import {Typography} from "@mui/material";

export function NotFoundPage() {
    return <>
        <Typography variant="h2" mt={5}>
            404 - Diese Seite existiert nicht
        </Typography>
    </>;
}